import React, { useEffect } from 'react'
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField'
import { AddIcon } from './formUtil';
import { toast } from 'react-toastify';

import DisplayStumpCategory from '../../components/AI/AK';


/**
 * This component displays a form for aligning a stump. It includes a data analysis section where the user can input the circumference of the stump and analyze its length category. It also includes a section for setting parameters for the alignment.
 * @returns {JSX.Element} The JSX element for the form.
 */
const FormAlign_3 = () => {
  const style         = SideStyle();
  const SetCameraOut  = Control.Get('SetCameraOut');
  const setParam      = Param.Get('setParam');
  const setup         = Param.Get('setup');
  const align         = Param.Get('align');

  SetCameraOut(0, 0); // first augment is side of the leg and alwais is zero for AK.

  /**
   * Sets the preset parameters for the alignment based on the stump length and circumference.
   * @param {number} stumpLength - The length of the stump.
   * @param {number} circumference - The circumference of the stump.
   */
  const presetParameters = (stumpLength, circumference) => {
    // Preset fillet side wall
    if (circumference >= 600) {
      setParam(s => {s.baseshape.filletSideWall = 80});
    } else if (circumference >= 500 && circumference < 600) {
      setParam(s => {s.baseshape.filletSideWall = 70});
    } else if (circumference >= 400 && circumference < 500) {
      setParam(s => {s.baseshape.filletSideWall = 60});
    } else if (circumference < 400) {
      setParam(s => {s.baseshape.filletSideWall = 50});
    }

    // Preset Rectus femoris overhang
    if (circumference >= 650) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 24});
    } else if (circumference >= 600 && circumference < 650) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 22});
    } else if (circumference >= 550 && circumference < 600) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 20});
    } else if (circumference >= 500 && circumference < 550) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 18});
    } else if (circumference >= 450 && circumference < 500) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 16});
    } else if (circumference >= 400 && circumference < 450) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 14});
    } else if (circumference < 400) {
      setParam(s => {s.baseshape.rectusFemorisOverhang = 12});
    }
  }

  /**
   * Handles the stump analysis when the user inputs the circumference of the stump.
   * @param {object} e - The event object.
   */
  const handleStumpAnalysis = (e) => {
    const stumpLength = Math.round(align.stumpLength + align.stumpLengthAdjust);

    DisplayStumpCategory(stumpLength);
  }

  /**
   * Handles the input value change for the alignment parameters.
   * @param {object} e - The event object.
   */
  const handleValue = (e) => {
    const stumpLength = Math.round(align.stumpLength + align.stumpLengthAdjust);
    const circumference = e.target.value;

    setParam(s => {s.align[e.target.name] = Number(e.target.value)});

    presetParameters(stumpLength, circumference);

  };

  return (
    <>
      <Box mb={5} />
      <Grid container direction="row" spacing={1}>
        {(process.env.REACT_APP_AI == 1) &&
        <Grid item xs={12}>
          <p>Data Analysis</p>
        </Grid>
        }

        {(process.env.REACT_APP_AI == 1) &&
        <TextField
          id='filled-number'
          name='manualCircumference'
          label='Circumference(IT level)'
          type='number'
          defaultValue={align.manualCircumference}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 
            <AddIcon 
              unit='mm' 
              helptext={''}
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1,
            max:1000,
            step:1
          }}
        />
        }

        {(process.env.REACT_APP_AI == 1) &&
        <Grid item xs={12}>
          <Button className={style.buttonImportant} onClick={handleStumpAnalysis}>Stump Analysis</Button>
        </Grid>
        }
      </Grid>
    </>
  );
}

export default FormAlign_3;
